import _ from 'lodash';

import { calculate } from '@moleculeone/draw';
import { SVGMol } from '@moleculeone/ui';

export function applyMapping(mol: any, mapping: any) {
  const atomKeys = Object.keys(mol.atoms);

  if (atomKeys.length !== mapping.length) {
    return mol;
  }

  const molCopy = _.cloneDeep(mol);

  atomKeys.forEach(key => {
    const idx = Number(mol.atoms[key].idx);
    molCopy.atoms[key].classNum = mapping[idx];
  });

  return molCopy;
}

export function getDrawingRandomSeed(seedId: string) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);

  return Number.isFinite(seed) ? seed : 0;
}

export function incrementDrawingRandomSeed(seedId: string) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);
  const nextSeed = Number.isFinite(seed) ? seed + 1 : 1;

  SVGMol.randomSeeds[seedId] = String(nextSeed);

  return nextSeed;
}

export function calculateSeededPositions({
  mol,
  seedId,
  incrementSeed = false,
  ...restParams
}: {
  mol: any;
  seedId: string;
  incrementSeed?: boolean;
}) {
  let randomSeed;

  if (!incrementSeed) {
    randomSeed = getDrawingRandomSeed(seedId);
  } else {
    randomSeed = incrementDrawingRandomSeed(seedId);
  }

  return calculate(mol, {
    ...restParams,
    randomSeed,
  });
}
